import $ from 'jquery';

window.jQuery = $;
window.$ = $;

import Vars from '../../vars';

import Loader from '../../components/loader';
import Modal from '../../components/Modal';
import Request from '../../components/request';
import Router from '../../components/router';
import Utils from '../../components/utils';

import Auth from './Auth'
import Reg from './Reg'
import Remind from './Remind'

import Account from './Account';
import Building from './Building';
import Cash from './Cash';
import Company from './Company';
import Complex from './Complex';
import Conversation from './Conversation';
import Crm from './Crm';
import Feed from './Feed';
import Partner from './Partner';
import Payment from './Payment';
import Promocode from './Promocode';
import Requisition from './Requisition';
import Right from './Right';
import Site from './Site';
import Social from './Social';
import Tariff from './Tariff';
import Transaction from './Transaction';
import Widget from './Widget';

if (typeof global.loader === "undefined" || typeof global.loader === undefined){
    global.loader = Loader.init();
}

const app = {
    _elems : {
        $header  : $(),
        $aside   : $(),
        $content : $()
    },

    _state : {
        route : null
    },

    _functions : function () {
        window.ifacade_format_price = function(value) {
            value = Math.round(value * 100) / 100;
            return String(value).replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');
        };
        window.ifacade_format_phone = function(value) {
            return value.slice(0, 1) + ' (' + value.slice(1, 4) + ') ' + value.slice(4, 7) + '-' + value.slice(7, 9) + '-' + value.slice(9, 11);
        };
        window.ifacade_format_date_short = function(date) {
            const months = [ 'января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря' ];
            const day = date.getDate();
            const month = months[date.getMonth()];
            const year = date.getFullYear();
            return day + ' ' + month + ' ' + year;
        };
        window.ifacade_format_date = function(date) {
            const months = [ 'января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря' ];
            const day = date.getDate();
            const month = months[date.getMonth()];
            const year = date.getFullYear();
            const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
            const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            return day + ' ' + month + ' ' + year + ' в ' + hours + ':' + minutes;
        };
        window.ifacade_SVGfyPolygonCoordinates = function(polygon, height) {
            return polygon.coordinates.map(function(point) {
                return [
                    point[0],
                    height - point[1],
                ].join(',');
            }).join(' ');
        };
        window.ifacade_findKey = function (dataObj, value){
            for (let key in dataObj){
                if(dataObj.hasOwnProperty(key) && dataObj[key] == value){
                    return key;
                }
            }
            return false;
        };
        window.ifacade_findWithAttr = function (array, attr, value){
            for (let i = 0; i < array.length; i += 1) {
                if(array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        }
    },

    _setTitle : function(title){
        document.title = title + '. ' + Vars.title;
    },

    _initRouter : function() {
        let self = this;
        if (window.location.href.indexOf('login') !== -1) {
            loader.decrease();

            new Auth()
            return
        }
        else if (window.location.href.indexOf('registration') !== -1) {
            loader.decrease();

            new Reg()
            return
        }
        else if (window.location.href.indexOf('remind') !== -1) {
            loader.decrease();

            new Remind()
            return
        }

        self._state.route = Router.init({
            routes: [
                {
                    path: /^$|^#$/i,
                    on: function() {
                        window.location.href = '/profile#objects';
                    },
                },
                {
                    path: /^#objects$/i,
                    on: function() {
                        loader.increase();

                        const title = 'Жилые комплексы'

                        self._setTitle(title);

                        new Complex({
                            mode  : Vars.view.list,
                            title : title
                        });
                    }
                },
                {
                    path: /^#objects\/([0-9]+)$/i,
                    on: function (objectId) {
                        loader.increase();

                        const title = 'Дома';

                        self._setTitle(title);

                        new Complex({
                            mode  : Vars.view.item,
                            id    : objectId,
                            title : title
                        });
                    }
                },
                {
                    path: /^#objects\/([0-9]+)\/import$/i,
                    on: function (objectId) {
                        loader.increase();

                        self._setTitle('Импорт помещений в комплексе №' + objectId);

                        new Complex({
                            mode : Vars.view.import,
                            id   : objectId
                        });
                    }
                },
                {
                    path: /^#objects\/([0-9]+)\/buildings\/([0-9]+)$/i,
                    chess: null,
                    on: function(objectId, buildingId) {
                        loader.increase();

                        self._setTitle('Редактирование дома №' + buildingId);

                        new Building({
                            mode     : Vars.view.item,
                            objectId : objectId,
                            id       : buildingId
                        });
                    },
                    off: function() {
                        //chess && chess.destroy();
                    }
                },
                {
                    path: /^#objects\/([0-9]+)\/buildings\/([0-9]+)\/import$/i,
                    on: function (objectId, buildingId) {
                        loader.increase();

                        self._setTitle('Импорт помещений в доме №' + buildingId);

                        new Building({
                            mode     : Vars.view.import,
                            objectId : objectId,
                            id       : buildingId
                        });
                    }
                },
                {
                    path: /^#companies$/i,
                    on: function() {
                        loader.increase();

                        const title = 'Компании';
                        self._setTitle(title);

                        new Company({
                            mode  : Vars.view.list,
                            title : title
                        });
                    }
                },
                {
                    path: /^#companies\/([0-9]+)$/i,
                    on: function(id) {
                        loader.increase();

                        self._setTitle('Редактирование компании №' + id);

                        new Company({
                            mode : Vars.view.item,
                            id   : id
                        });
                    }
                },
                {
                    path: /^#sites$/i,
                    on: function() {
                        loader.increase();

                        self._setTitle('Управление сайтами');

                        new Site({
                            mode : Vars.view.list
                        });
                    }
                },
                {
                    path: /^#sites\/([0-9]+)$/i,
                    on: function(siteId) {
                        loader.increase();

                        self._setTitle('Редактирование сайта №' + siteId);

                        new Site({
                            mode    : Vars.view.item,
                            site_id : siteId
                        });
                    }
                },
                {
                    path: /^#widgets$/i,
                    on: function() {
                        loader.increase();

                        const title = 'Виджеты'

                        self._setTitle(title);

                        new Widget({
                            mode    : Vars.view.list,
                            title   : title
                        });
                    }
                },
                {
                    path: /^#widgets\/([0-9]+)_([0-9]+)$/i,
                    on: function(prefixId, suffixId) {
                        loader.increase();

                        self._setTitle('Редактирование виджета №' + prefixId + '_' + suffixId);

                        new Widget({
                            mode   : Vars.view.item,
                            prefix : prefixId,
                            suffix : suffixId
                        });
                    }
                },
                {
                    path: /^#feeds$/i,
                    on: function() {
                        loader.increase();

                        const title = 'Фиды'

                        self._setTitle(title);

                        new Feed({
                            mode    : Vars.view.list,
                            title   : title
                        });
                    }
                },
                {
                    path: /^#feeds\/([0-9]+)_([0-9]+)$/i,
                    on: function(prefixId, suffixId) {
                        loader.increase();

                        self._setTitle('Редактирование фида №' + prefixId + '_' + suffixId);

                        new Feed({
                            mode   : Vars.view.item,
                            prefix : prefixId,
                            suffix : suffixId
                        });
                    }
                },
                {
                    path: /^#rights$/i,
                    on: function() {
                        self._setTitle('Доступы');
                        new Right({
                            page : Vars.page.list
                        });
                    }
                },
                {
                    path: /^#rights\/objects/i,
                    on: function() {
                        self._setTitle('Поиск жилых комплексов');

                        let url = new URL(window.location.href);
                        let get = url.hash.substring(15);
                        new Right({
                            page : Vars.page.right.objects,
                            get  : get
                        });
                    }
                },
                {
                    path: /^#rights\/inside/i,
                    on: function() {
                        self._setTitle('Входящие запросы');
                        new Right({
                            page : Vars.page.right.inside
                        });
                    }
                },
                {
                    path: /^#rights\/outside/i,
                    on: function() {
                        self._setTitle('Исходящие запросы');
                        new Right({
                            page : Vars.page.right.outside
                        });
                    }
                },
                {
                    path: /^#socials$/i,
                    on: function () {

                        const title = 'Социальные сети'

                        self._setTitle(title);

                        new Social({
                            page  : Vars.view.list,
                            title : title
                        });
                    }
                },
                {
                    path: /^#socials\/vk$/i,
                    on: function () {
                        const title = 'Товары ВКонтакте';
                        self._setTitle(title);
                        new Social({
                            page : Vars.page.social.vk
                        });
                    }
                },
                {
                    path: /^#socials\/vk\/([0-9]+)$/i,
                    on: function (id) {
                        const title = 'Сообщество ВКонтакте №' + id;
                        self._setTitle(title);
                        new Social({
                            page : Vars.page.item,
                            id   : id
                        });
                    }
                },{
                    path: /^#crms$/i,
                    on: function () {
                        const title = 'Интеграции с CRM';
                        self._setTitle(title);
                        new Crm({
                            page  : Vars.page.list,
                            title : title
                        });
                    }
                },
                {
                    path: /^#crms\/([0-9]+)$/i,
                    on: function(id) {
                        const title = 'Редактирование интеграции №' + id;
                        self._setTitle(title);
                        new Crm({
                            page : Vars.page.item,
                            id   : id
                        });
                    }
                },
                {
                    path: /^#cash$/i,
                    on: function () {
                        const title = 'Мой кошелек';
                        self._setTitle(title);
                        new Cash({
                            mode  : Vars.view.list,
                            title : title
                        });
                    }
                },
                {
                    path: /^#cash\/balance$/i,
                    on: function () {
                        const title = 'Мой баланс';
                        self._setTitle(title);

                        new Cash({
                            mode  : Vars.view.item,
                            title : title
                        });
                    }
                },
                {
                    path: /^#cash\/transactions$/i,
                    on: function () {
                        const title = 'Мои транзакции';
                        self._setTitle(title);

                        new Transaction({
                            page    : Vars.view.list,
                            title   : title
                        });
                    }
                },
                {
                    path: /^#cash\/transactions\/([0-9-]+)$/i,
                    on: function (id) {
                        const title = 'Транзакция №' + id;
                        self._setTitle(title);
                        new Transaction({
                            page : Vars.page.item,
                            id   : id
                        });
                    }
                },
                {
                    path: /^#cash\/payments$/i,
                    on: function () {
                        const title = 'Мои счета';
                        self._setTitle(title);

                        new Payment({
                            page    : Vars.view.list,
                            title   : title
                        });
                    }
                },
                {
                    path: /^#cash\/payments\/([0-9-]+)$/i,
                    on: function (number) {
                        const title = 'Счёт №' + number;
                        self._setTitle(title);
                        new Payment({
                            page   : Vars.page.item,
                            number : number,
                            title  : title
                        });
                    }
                },
                {
                    path: /^#tariffs$/i,
                    on: function () {
                        const title = 'Тарифные планы';
                        self._setTitle(title);
                        new Tariff({
                            page  : Vars.page.list,
                            title : title
                        });
                    }
                },
                {
                    path: /^#payments$/i,
                    on: function () {
                        const title = 'Мои счета';
                        self._setTitle(title);
                        new Payment({
                            page  : Vars.page.list,
                            title : title
                        });
                    }
                },
                {
                    path: /^#payments\/([0-9-]+)$/i,
                    on: function (number) {
                        const title = 'Счёт №' + number;
                        self._setTitle(title);
                        new Payment({
                            page   : Vars.page.item,
                            number : number,
                            title  : title
                        });
                    }
                },
                {
                    path: /^#conversations$/i,
                    on: function() {
                        const title = 'Мои диалоги';
                        self._setTitle(title);
                        new Conversation({
                            mode  : Vars.view.list,
                            title : title
                        });
                    }
                },
                {
                    path: /^#conversations\/support$/i,
                    on: function () {
                        loader.increase();

                        return Request.send({
                            path: '/api/conversations/support/',
                            done: function(response){
                                window.location.href = '/profile/#conversations/' + response.conversation.hash;
                                loader.decrease();
                            }
                        });
                    }
                },
                {
                    path: /^#conversations\/object_right_([0-9]+)$/i,
                    on: function (id) {
                        loader.increase();

                        Request.send({
                            path: '/api/conversations/object_right_' + id + '/',
                            done: function(response){
                                window.location.href = '/profile/#conversations/' + response.conversation.hash;
                                loader.decrease();
                            }
                        })
                    }
                },
                {
                    path: /^#conversations\/object_([0-9]+)$/i,
                    on: function (id) {
                        loader.increase();

                        Request.send({
                            path: '/api/conversations/object_' + id + '/',
                            done: function(response){
                                window.location.href = '/profile/#conversations/' + response.conversation.hash;
                                loader.decrease();
                            }
                        })
                    }
                },
                {
                    path: /^#conversations\/([$.a-zA-Z0-9]+)$/i,
                    on: function(hash) {
                        loader.increase();

                        const title = 'Мои сообщения';
                        self._setTitle(title);

                        new Conversation({
                            mode  : Vars.view.item,
                            title : title,
                            hash  : hash
                        });
                    }
                },
                {
                    path: /^#requests/i,
                    on: function() {
                        const title = 'Мои заявки';
                        self._setTitle(title);
                        new Requisition({
                            page  : Vars.page.list,
                            title : title
                        });
                    }
                },
                {
                    path: /^#partners/i,
                    on: function() {
                        loader.increase();

                        const title = 'Партнеры';
                        self._setTitle(title);
                        new Partner({
                            page  : Vars.page.list,
                            title : title
                        });
                    }
                },
                {
                    path: /^#promocodes/i,
                    on: function() {
                        loader.increase();

                        const title = 'Промокоды';
                        self._setTitle(title);
                        new Promocode({
                            page  : Vars.page.list,
                            title : title
                        });
                    }
                },
                {
                    path: /^#account$/i,
                    on: function () {
                        loader.increase();

                        const title = 'Регистрационная информация';
                        self._setTitle(title);

                        new Account({
                            title : title
                        });
                    }
                },
                {
                    path: /^#account\/([a-z]+)\/dublicate$/i,
                    on: function () {
                        window.location.href = '/profile#account';
                    }
                },
                {
                    path: /^#account\/success$/i,
                    on: function () {
                        loader.decrease();
                        new Modal({
                            title: 'Аккаунт привязан',
                            content: Utils.renderProfileTemplate('info', {
                                message: 'Данный аккаунт социальной сети успешно привязан к вашему аккаунту на ifacade.ru',
                                buttons: {
                                    one: {
                                        class: 'confirm button--edit',
                                        title: 'Хорошо'
                                    },
                                    two: null
                                }
                            }),
                            confirm: function (args) {
                                let $modal = args.modal;
                                if (!$modal.length) return;

                                $modal.trigger('close');
                                window.location.href = '/profile#account';
                            }
                        });
                    }
                },
            ],
            update : function() {
                self._elems.$aside.trigger('update');
            }
        });
    },

    _bindElements : function() {
        let self = this;
        self._elems.$header = $('.header');
        self._elems.$aside = $('.aside');
        self._elems.$content = $('.content');
    },
    _bindUI : function() {
        let self = this;

        $(document).ready(function(){
            self._initRouter();
        });

        self._elems.$aside.on('update', function(){
            Request.send({
                path : '/api/pages/aside',
                data : {
                    current : window.location.hash.substr(1)
                },
                done : function(response) {
                    Utils.scrollToTop();

                    let items    = response.items;

                    self._elems.$aside.html(Utils.renderProfileTemplate('aside', {
                        columns     : 3,
                        entity      : 'index',
                        entities    : null,
                        actions     : false,
                        group       : true,
                        items       : items,
                        item_id     : null,
                        detail      : false
                    }));

                    let tariff = response.header.tariff;
                    let messages = response.header.messages;

                    if (tariff && tariff.name != 'base' && tariff.deadline > 0) {
                        self._elems.$header.find('.header-developer-deadline').text('+' + tariff.deadline + ' дней').show();
                    }
                    if (tariff) {
                        self._elems.$header.find('.header-developer-title').text('«' + tariff.display_name + '»');
                        self._elems.$header.find('.header-cash').show()
                        self._elems.$header.find('.header-cash-balance span').text(tariff.balance);
                    }

                    self._elems.$header.find('.header-msg-count').text(messages);
                }
            });
        });

        window.addEventListener('error', function(event) {
            var error = event.error;

            $.ajax({
                method: 'POST',
                url: '/api/error_log',

                data: {
                    url: 		window.location.href,
                    auth: 		auth,
                    message: 	error.message,
                    stack: 		error.stack,
                    timestamp: 	Math.floor(Date.now() / 1000),
                    userAgent: 	navigator && navigator.userAgent,
                }
            });

            new Modal({
                title: 'Ошибка',
                content: Utils.renderProfileTemplate('error', {
                    error : {
                        text : 'Произошла непредвиденная ошибка, техническая поддержка сайта уже проинформирована и занимается ее устранением. Приносим извинения за временные неудобства.'
                    },
                    buttons : {
                        one : {
                            class : 'confirm button--edit',
                            title : 'Хорошо'
                        },
                        two : null
                    }
                }),
                confirm : function(args) {
                    args.modal && args.modal.trigger('close');
                }
            });
        });

        document.addEventListener("webkitfullscreenchange", function(evt) {
            $('body').toggleClass('_fullscreen');
        });
        document.addEventListener("mozfullscreenchange", function(evt) {
            $('body').toggleClass('_fullscreen');
        });
        document.addEventListener("MSFullscreenChange", function(evt) {
            $('body').toggleClass('_fullscreen');
        });
        document.addEventListener("fullscreenchange", function(evt) {
            $('body').toggleClass('_fullscreen');
        });
    },
    init : function () {
        let self = this;

        self._functions();
        self._bindElements();
        self._bindUI();
    }
};

export default app;